export default __webpack_public_path__ + "static/banner2-d038c8944eaa912d973a2b194fa806d9.svg";